import { Button, Container, Grid } from "@mui/material";
import React from "react";
import { SectionHeading, SectionWrapper } from "../../Styles/style";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import footerman from "../../../assets/images/footerman.png"
import arrow from "../../../assets/images/0protocol.png"


import Videostars from "../../../assets/images/mixed.mp4"


 const MixerButton  = styled(Button)`
 padding:20px;
 background-color:rgb(23, 77, 255);
 color:#fff;

 `
 const BuyNow = styled.a`
text-decoration: none;
background-color: #174DFF;
color:  #fff;
padding: 12px 20px;
border-radius: 50px;
display: flex;
max-width: 160px;
align-items: center;
margin-top:30px;

`
const ManImg = styled.img`
width: 100%;
height: auto;
max-width: 500px;
`
const GridWrapper = styled(Grid)`
display: flex;
align-items: center;
`
const GridWrapperss = styled(Grid)`
display: flex;
align-items: center;
// @media (max-width: 425px) {
//   display:block;
//   text-align-last: center !important;
// }

`
const VideoBK = styled.video`
  object-fit: cover;
  width: 100%;
  max-width: 100%;
  height: auto;
`;
const GridVideo = styled(Grid)`
mix-blend-mode: lighten !important;
`;
const BottomGrid = styled.div`
box-sizing: border-box;
margin: 20px 0px;
flex-direction: row;
flex-basis: 100%;
-webkit-box-flex: 0;
flex-grow: 0;
max-width: 100%;
text-align: left;
display: grid;
grid-template-columns: auto auto auto auto;
gap: 22px 10px;
place-items: left;

@media (max-width: 425px) {
  grid-template-columns: auto auto;
  place-items: center;
  text-align: center;
}
`
const ChildGrid = styled.div`
    justify-self: center;
// text-align-last: left;
// @media (max-width: 768px) {
  // text-align-last: center !important;
// }
`
const P = styled.p`
  font-weight: ${(props) => (props.fw ? props.fw : "")};
  font-family: "P-L";
  font-size: ${(props) => (props.fs ? props.fs : "18px")};
  color: ${(props) => (props.color ? props.color : props.theme.textPrimary)};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin: ${(props) => (props.m ? props.m : "20px 0")};
  padding: ${(props) => (props.p ? props.p : "")};
  display: ${(props) => (props.display ? props.display : "")};
  justify-content: ${(props) => (props.jc ? props.jc : "")};
  border-bottom: 1px solid #fff;
  padding-bottom:70px;
  @media (max-width: 600px) {
    font-size: ${(props) => (props.fs600px ? props.fs600px : "")};
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;
const P1 = styled.p`
  margin-bottom: 0 !important;
  font-weight: ${(props) => (props.fw ? props.fw : "900")};
  font-family: "P-L";
  font-size: ${(props) => (props.fs ? props.fs : "20px")};
  color: ${(props) => (props.color ? props.color : props.theme.textPrimary)};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin: ${(props) => (props.m ? props.m : "20px 0")};
  padding: ${(props) => (props.p ? props.p : "")};
  display: ${(props) => (props.display ? props.display : "")};
  justify-content: ${(props) => (props.jc ? props.jc : "")};
  @media (max-width: 600px) {
    font-size: ${(props) => (props.fs600px ? props.fs600px : "")};
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;
const P2 = styled.p`
  margin:0 !important;
  font-weight: ${(props) => (props.fw ? props.fw : "")};
  font-family: "P-L";
  font-size: ${(props) => (props.fs ? props.fs : "14px")};
  color: ${(props) => (props.color ? props.color : props.theme.textPrimary)};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin: ${(props) => (props.m ? props.m : "20px 0")};
  padding: ${(props) => (props.p ? props.p : "")};
  display: ${(props) => (props.display ? props.display : "")};
  justify-content: ${(props) => (props.jc ? props.jc : "")};
  @media (max-width: 600px) {
    font-size: ${(props) => (props.fs600px ? props.fs600px : "")};
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;
const Para = styled.p`
  font-weight: ${(props) => (props.fw ? props.fw : "900")};
  font-family: "P-L";
  font-size: ${(props) => (props.fs ? props.fs : "25px")};
  color: ${(props) => (props.color ? props.color : props.theme.textPrimary)};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  margin: ${(props) => (props.m ? props.m : "20px 0")};
  padding: ${(props) => (props.p ? props.p : "")};
  display: ${(props) => (props.display ? props.display : "")};
  justify-content: ${(props) => (props.jc ? props.jc : "")};
  border-top: 1px solid #fff;
  padding-top:30px;
  @media (max-width: 600px) {
    font-size: ${(props) => (props.fs600px ? props.fs600px : "")};
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "0px")};
  }
`;
const Section8_Team = () => {
  const theme = useTheme()
  return (
    <SectionWrapper p799="8rem 0 8rem 0" p599="8rem 0px 8rem 0" p="4rem 0 4rem 0" id="about">
      <Container maxWidth="xl" >
        <GridWrapper container>
        
         
          <Grid item xs={12} md={6}
          data-aos-easing="fade-right"
          data-aos-delay="400"
          data-aos-duration="500"
          data-aos-offset="0"
          >
            <SectionHeading p="20px 0" m="0" align="left" color={theme.textSecondary} data-aos="flip-up"
              data-aos-easing="ease-in"
              data-aos-delay="400"
              data-aos-duration="500"
              data-aos-offset="0" >
              <img src={arrow} width='45' /> ØERO PROTOCOL
            </SectionHeading>
            <P p="0" m="0" color={theme.textSecondary} data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="500"
              data-aos-duration="500"
              data-aos-offset="0" >Our zero-knowledge ecosystem will host services that helps users maintain their
              privacy online. Whether it's a transaction you want to keep away from prying eyes or
              a just want to keep your business to yourself, the Øreo protocol aims to keep you
              covered.

            </P>
            <Para p="0" m="0" color={theme.textSecondary} data-aos="fade-zoom-in"
              data-aos-easing="ease-in"
              data-aos-delay="500"
              data-aos-duration="500"
              data-aos-offset="0" >
                Token Details
            </Para>
            <BottomGrid>
            <ChildGrid item xs={12} md={3}>
            <img src={arrow} width='45' />
            <P1>1 Billion</P1>
            <P2>Supply</P2>
            </ChildGrid>
            <ChildGrid item xs={12} md={3}>
            <img src={arrow} width='45' />
            <P1>4/5</P1>
            <P2>Tax</P2>
            </ChildGrid>
            <ChildGrid item xs={12} md={3}>
            <img src={arrow} width='45' />
            <P1>12.36 ETH</P1>
            <P2>Liquidity</P2>
            </ChildGrid>
            <ChildGrid item xs={12} md={3}>
            <img src={arrow} width='45' />
            <P1>19 ETH</P1>
            <P2>Buy Backs</P2>
            </ChildGrid>
            </BottomGrid>
            {/* <img src={arrow} />
            <BuyNow href="/#home">Open Dapp</BuyNow> */}
          </Grid>
          
         
          <GridVideo
            xs={12}
            md={6}
            data-aos="fade-left"
            data-aos-easing="ease-in"
            data-aos-delay="400"
            data-aos-duration="700"
            data-aos-offset="0"
          >
            <VideoBK autoPlay loop muted>
              <source src={Videostars} type="video/mp4" />
            </VideoBK>
          </GridVideo>
          
        </GridWrapper>
      </Container>
    </SectionWrapper>
  )
};

export default Section8_Team;
